import server_config from './server_config.js'

// var api_url = 'http://51.143.100.135:8080';
// var api_username =  '';
// var default_password = '';
// //var api_username =  'Ls6X9iIKgyv1XamSnMtwQGEFWJCS4Z2K';
// //var default_password = 'D2maVAWzGNtfOUqYRfmUussUqBGD78MCAbCkV6J9eyGdZEWP';

export default {
  apiUrl: function () {
    return server_config.api_url;
  },
  defaultUsername: function () {
    return server_config.api_username;
  },
  defaultPassword: function () {
    return server_config.default_password;
  }
}


// WEBPACK FOOTER //
// ./src/config.js